var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLogoNoText = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 50,
    viewBox: "0 0 74 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__b",
    d: "M0 0.047L19.598 0.047 19.598 21 0 21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__d",
    d: "M0.075 0.212L7.999 0.212 7.999 7.618 0.075 7.618z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a",
    width: "212.2%",
    height: "253.3%",
    x: "-56.1%",
    y: "-76.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#prefix__a)",
    transform: "translate(-1 8) translate(18)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F9B504",
    d: "M40.886 10.937c.507-1.176-.772-2.339-1.964-1.776-2.097.989-4.859 1.859-7.89 1.859-3.05 0-5.84-.88-7.958-1.875-1.19-.56-2.466.603-1.96 1.777l7.612 17.62c.84 1.944 3.716 1.944 4.557 0l7.603-17.605z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__b"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C76306",
    d: "M7.564 1.502L.112 19.067C-.385 20.24.87 21.4 2.038 20.84c2.054-.988 4.758-1.858 7.73-1.858 2.988 0 5.723.878 7.799 1.873 1.166.559 2.417-.603 1.919-1.774l-7.46-17.579c-.821-1.94-3.64-1.94-4.462 0",
    mask: "url(#prefix__c)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F9B504",
    d: "M34.684 3.915c0-2.047-1.671-3.704-3.73-3.704-2.056 0-3.727 1.657-3.727 3.704 0 2.044 1.67 3.703 3.727 3.703 2.059 0 3.73-1.66 3.73-3.703"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__d"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C76306",
    d: "M7.999 3.915c0-2.047-1.774-3.704-3.963-3.704C1.85.211.075 1.868.075 3.915c0 2.044 1.775 3.703 3.96 3.703C6.226 7.618 8 5.958 8 3.915",
    mask: "url(#prefix__e)"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogoNoText, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logoNoText.ee436c4b.svg";
export { ForwardRef as ReactComponent };